import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from '../httpBase/httpBase.service';
import { ENDPOINTS_COMMON } from '../../constants/ENDPOINTS';
import { ContactUsRequest, ContactUsResponse } from '../../models/contact-us';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService extends HttpBaseService {
  sendMessage(payload: ContactUsRequest): Observable<ContactUsResponse> {
    const url = ENDPOINTS_COMMON.CONTACT_US.POST_CONTACT_US;
    return this.post(
      url,
      payload,
      undefined,
      true
    ) as Observable<ContactUsResponse>;
  }
}
